import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const BlogSection = () => {
  const [blogSection, setBlogSection] = useState([]);
  const [allBlogs, setAllBlogs] = useState([]);
  useEffect(() => {
    axios.get("JSON/news&events.json").then((response) => {
      setBlogSection(response.data[0]);
      setAllBlogs(response.data[0].blogs.reverse());
    });
  }, []);
  return (
    <>
      <section className="blog-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="section-head">
                <h3 className="section-head-title">
                  {" "}
                  {blogSection?.section_title}
                </h3>
                <p className="section-head-text">
                  {blogSection?.section_detail}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-xl-6 col-12">
              <div className="blog-card card-big">
                <div className="blog-card-img">
                  <img src={allBlogs[0]?.img} alt="#" />
                  <span className="blog-card-category">
                    {allBlogs[0]?.category}
                  </span>
                </div>
                <div className="blog-card-content card-big-content">
                  <ul className="blog-meta-list">
                    <li>
                      <Link to="#">
                        <i className="fi fi-rr-alarm-clock"></i>
                        {allBlogs[0]?.date}
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fi fi-rr-user"></i>by{" "}
                        {allBlogs[0]?.writer}
                      </Link>
                    </li>
                  </ul>
                  <h4 className="blog-card-title">
                    <Link to="/blogsingle">{allBlogs[0]?.title}</Link>
                  </h4>
                  <Link to="/blogsingle" className="eschool-btn">
                    Read more<i className="fi fi-rs-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-6 col-12">
              <div className="blog-card-right">
                {allBlogs?.slice(1, 4)?.map((singleBlog) => (
                  <div className="blog-card card-small">
                    <div className="blog-card-img blog-card-sm-img">
                      <img src={singleBlog?.img} alt="#" />
                      <span className="blog-card-category">
                        {singleBlog.category}
                      </span>
                    </div>
                    <div className="blog-card-content card-sm-content">
                      <ul className="blog-meta-list">
                        <li>
                          <Link to="#">
                            <i className="fi fi-rr-alarm-clock"></i>
                            {singleBlog?.date}
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fi fi-rr-user"></i>by{" "}
                            {singleBlog?.writer}
                          </Link>
                        </li>
                      </ul>
                      <h4 className="blog-card-title">
                        <Link to="/blogsingle">{singleBlog?.title}</Link>
                      </h4>
                      <Link to="/blogsingle" className="eschool-btn">
                        Read more<i className="fi fi-rs-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="blog-bottom-btn">
                <Link to="#" className="eschool-btn secondary-btn">
                  Explore More<i className="fi fi-rs-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogSection;
